<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >

      <Form-item label="作品">
        <Tag v-for="(arts, idx) in artsList" :key="idx" :color="['primary', 'red', 'orange', 'green'][idx%4]" type="border">{{ arts.artist.name + "(" + arts.title + ")" }}</Tag>
      </Form-item>

      <Form-item label="选择画展" prop="artshowId">
        <c-artshow-select
          class="c-form__input"
          v-model.trim="cForm.model.artshowId"
           @change="
              value => {
                this.cForm.model.artshowId = value;
              }
            "
        >
        </c-artshow-select>
      </Form-item>
       
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "artshow";

@Component({
  mixins: [FormMixin]
})
export default class SelectArtListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        artsList: [],
        model: this.getFormInitModel(),
        rules: {
          artshowId: [
            {
              required: true,
              message: "画展 不能为空"
            }
          ],
        }
      }
    };
  }

  getFormInitModel() {
    return {
      artsIds:[],
      artshowId: null,
    };
  }

  show(artsList) {
    this.cForm.modal = true;

    this.artsList = artsList;
    this.cForm.model.artsIds = artsList.map(function(a) {
        return a['id']
    });
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { model } = this.cForm;
        await this.$store.dispatch(
          `${module}/selectArts`,
          {
            body: model
          }
        );

        this.cForm.modal = false;
        this.$Message.success('发布成功');
        this.$router.push(`/dresses/brands/artshow/list/items?id=${this.cForm.model.artshowId}`);
        // this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
